import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { BigBlueButtonService } from '../../../_services/_etc/big-blue-button.service';
import {
  IAttendee,
  IBigBlueButtonSettings,
  ICustomApp,
  IWorkshopRoom,
  SplitscreenTool
} from '@sv/interfaces';
import { CustomAppService } from '../../../_services/_content/customApp.service';
import { TicketcodeAuthService } from '../../../_services/_auth/ticketcode-auth.service';
import { RegistrationService } from 'src/app/_services/_content/registration.service';
import { LoginService } from 'src/app/_services/_content/login.service';

@Component({
  selector: 'app-bigbluebutton',
  templateUrl: './bigbluebutton.component.html',
  styleUrls: ['./bigbluebutton.component.scss']
})
export class BigbluebuttonComponent implements OnInit, OnChanges {
  @Input() room: IWorkshopRoom;
  @Input() openFromBooth: boolean;

  SplitscreenTool = SplitscreenTool;

  constructor(
    private bigBlueButtonService: BigBlueButtonService,
    private customAppService: CustomAppService,
    private ticketcodeAuthService: TicketcodeAuthService,
    private registrationService: RegistrationService,
    private loginService: LoginService
  ) {}

  url: string;
  isLoading = true;
  splitscreen = false;
  attendee: IAttendee;
  customApp: ICustomApp;

  ngOnInit(): void {
    this.customAppService.getCustomAppListener().subscribe((app) => {
      this.customApp = app;
    });
  }

  ngOnChanges(): void {
    this.isLoading = true;
    if (!this.customApp) {
      this.customAppService.getCustomAppListener().subscribe((app) => {
        this.customApp = app;
        this.initBBB();
      });
    } else {
      this.initBBB();
    }
  }

  async initBBB() {
    if (typeof this.customApp.registration === 'string') {
      this.customApp.registration = await this.registrationService.getRegistrationById(this.customApp.registration);
    }
    if (typeof this.customApp.login === 'string') {
      this.customApp.login = await this.loginService.getLoginById(this.customApp.login);
    }

    if (this.customApp.login.enabled || this.customApp.registration.enabled) {
      this.attendee = this.ticketcodeAuthService.decodeToken();

      let isAdmin = false;
      let admincodes: string[] = [];
      if (this.room.adminCodes) {
        admincodes = this.room.adminCodes;
      }

      for (const code of admincodes) {
        if (
          this.attendee.ticketcode + '' === code ||
          this.attendee._id === code
        ) {
          isAdmin = true;
        }
      }

      let askAdmin = false;
      let isGuest;

      if (this.room.waitingRoom) {
        askAdmin = true;
        if (isAdmin) {
          isGuest = false;
        } else {
          isGuest = true;
        }
      }

      const bbbSettings: IBigBlueButtonSettings = {
          id: this.room.id,
          meetingName: this.room.name,
          attendeeName: this.attendee.name + ' ' + this.attendee.surname,
          attendeePassword: this.room.password,
          isAdmin,
          isGuest,
          askAdmin,
          hidePresentation: this.room.hidePresentation
        };

      this.bigBlueButtonService.join(bbbSettings, window.location.hostname).subscribe((res) => {
          this.url = res.data;
          this.isLoading = false;
        });
    } else {
      this.ticketcodeAuthService.login('4711', this.customApp.eventId).subscribe(() => {
        const bbbSettings: IBigBlueButtonSettings = {
          id: this.room.id,
          meetingName: this.room.name,
          attendeeName: 'Teilnehmer',
          attendeePassword: this.room.password,
          isAdmin: false,
          isGuest: false,
          askAdmin: undefined,
          hidePresentation: this.room.hidePresentation
        };
        this.bigBlueButtonService.join(bbbSettings, window.location.hostname).subscribe((res) => {
          this.url = res.data;
          this.isLoading = false;
        });
    });
  }
}

  toggleSplitscreen(): void {
    this.splitscreen = !this.splitscreen;
  }
}
